import React from 'react';
import { LineChart, Line, Label, XAxis, YAxis, CartesianGrid, ReferenceArea, ReferenceLine, Tooltip } from 'recharts';
import moment from 'moment';
import i18next from 'i18next';

class EventGraph extends React.Component {
  constructor(props) {
    super(props);

    // Calculate 15 minute ticks for x axis
    const data = this.props.data.map((obs) => ({...obs, timestamp: obs.timestamp * 1000})); // convert timestamp from seconds to milliseconds
    const firstTime = data.length == 0 ? 0 : data[0].timestamp; //in milliseconds (ms)
    const lastTime = data.length == 0 ? 0 : data[data.length - 1].timestamp;
    const tick1 = Math.ceil(firstTime / 1000 / 60 / 15) * 15 * 60 * 1000; // convert to quarter hours, round, convert back to ms
    const tickn = Math.floor(lastTime / 1000 / 60 / 15) * 15 * 60 * 1000;

    let ticks = [];
    for (let i = tick1; i <= tickn ; i = i + (60*15*1000)) {
      ticks.push(i);
    }

    this.state = {
      data: data,
      startTime: firstTime,
      endTime: lastTime,
      ticks: ticks,
    }
  }

  formatTick(tick) {
    moment.locale(i18next.language);
    return moment(tick).utc().format("LT");
  }

  render() {
    const data = this.state.data;
    const refLineY = this.props.threshold.value;
    const firstTime = this.state.startTime;
    const lastTime = this.state.endTime;
    const eventStart = this.props.eventRange.start * 1000;
    const eventEnd = Math.min(this.props.eventRange.end * 1000, lastTime);
    
    let minY = 99999999999;
    let maxY = -99999999999;
    data.forEach(dp => {
      if (dp.amount < minY) minY = dp.amount;
      if (dp.amount > maxY) maxY = dp.amount;
    });
    const range = maxY - minY;
    minY -= Math.round(range * 0.10);
    maxY += Math.round(range * 0.10);

    return (
      <LineChart width={this.props.width} height={this.props.height} data={data}>
        <CartesianGrid strokeDasharray="0 0" />

        <XAxis type="number" dataKey="timestamp" scale="time" ticks={this.state.ticks} domain={[firstTime, lastTime]} tickFormatter={(tick) => this.formatTick(tick)} height={50}>
          <Label value={`${i18next.t('graphing.date-time')}, ${i18next.t('graphing.start')}, ${i18next.t('graphing.end')}`} offset={10} position="insideBottom"/>
        </XAxis>
        <YAxis type="number" allowDecimals={true} domain={[minY, maxY]} interval={0}>
          <Label value={this.props.yAxisLabel} position="insideLeft" angle={-90} />
        </YAxis>

        <ReferenceLine y={refLineY} stroke="#e66" strokeOpacity={0.5} isFront={true} strokeWidth={3} ifOverflow="extendDomain"/>
        <ReferenceArea x1={eventStart} x2={eventEnd} strokeOpacity={0.9} />

        <Line type="step" dot={false} dataKey="amount" fill="rgb(76, 120, 168)" strokeWidth={2} isAnimationActive={false}/>
        <Line type="step" dot={true} dataKey="provisionalAmount" stroke="#e66" strokeWidth={2} isAnimationActive={false}/>
      </LineChart>
    );
  }

}

export default EventGraph;
